export default "__VITE_ASSET__1d68e726__"